import { TooltipBubble, type TooltipBubbleProps } from '@carboncopyco/ui';
import classNames from 'classnames';
import type React from 'react';
import type { MouseEventHandler, ReactNode } from 'react';

export interface SidebarButtonProps
  extends React.ComponentPropsWithRef<'button'> {
  isSelected: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  tooltipText: TooltipBubbleProps['title'];
  children: ReactNode;
}

export const SidebarButton = ({
  isSelected,
  onClick,
  tooltipText,
  children,
  ...rest
}: SidebarButtonProps) => {
  return (
    <TooltipBubble
      title={tooltipText}
      placement="right"
    >
      <button
        onClick={onClick}
        className={classNames(
          'w-ds-9 h-ds-9 flex items-center justify-center rounded-ds-md',
          {
            'text-ds-natural-600 hover:bg-ds-natural-150': !isSelected,
            'text-ds-accent3-100 bg-ds-natural-700': isSelected,
          }
        )}
        {...rest}
      >
        {children}
      </button>
    </TooltipBubble>
  );
};
